<div class="body">

    <div class="tag-panel">
        <div class="tag primary">{{ type }}</div>
    </div>

    <div *ngIf="mailSetted; else nullObject">

        <div class="headline">
            {{ currentMail.subject }}
        </div>

        <div class="footer">

            <div class="sub-title-wrapper">

                <div class="sub-title">

                    <span *ngIf="currentMail.transmitter">
                        {{ currentMail.transmitter.name }}<span class="email-address">{{ currentMail.transmitter.address }}</span>
                    </span>
        
                </div>
        
                <div class="sub-title">
                    Eingegangen {{ currentMail.received | date:"dd.MM.yyyy HH:mm" }} Uhr
                </div>

            </div>

            <mat-icon *ngIf="currentMail?.mailAttachements?.length > 0" matTooltip="Diese Mail enthält Anhänge ({{currentMail?.mailAttachements?.length}})">file_present</mat-icon>

        </div>

    </div>

    <ng-template #nullObject>
        FEHLER
    </ng-template>

</div>